import { render, staticRenderFns } from "./Mana.vue?vue&type=template&id=e63c2dbe&"
import script from "./Mana.ts?vue&type=script&lang=js&"
export * from "./Mana.ts?vue&type=script&lang=js&"
import style0 from "./Mana.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports